import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CurrencyIconElement } from './currencyIconElement';
export const JacksIconElement = ({ size }) => _jsx(CurrencyIconElement, { color: '#F4A361', size: size });
